import RedirectBackButton from "components/RedirectBackButton";
import useGlobalContext from "hooks/globalData";
import useTitle from "hooks/useTitle";
import { useMemo } from "react";
import { FormattedMessage as T, useIntl } from "react-intl";
import contextStore from "stores/contextStore";
import EmailThemeForm from "./EmailThemeForm";

export default function EmailThemeCreateForm() {
  const { formatMessage: t } = useIntl();
  const { emailThemeUrl } = useGlobalContext();
  const { organizationId, organizationName } = contextStore.useState();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const organizationIdMemo = useMemo(() => organizationId!, []);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const organizationNameMemo = useMemo(() => organizationName!, []);

  useTitle(
    t({ id: "addEmailThemeTitle" }, { organizationName: organizationNameMemo })
  );

  return (
    <>
      <RedirectBackButton
        redirectRoute={emailThemeUrl()}
        labelKey="backToDetailsButtonLabel"
      />
      <h2>
        <T id="addEmailTheme" />
      </h2>
      <EmailThemeForm
        submitLabel={t({ id: "createEmailTheme" })}
        organizationId={organizationIdMemo}
      />
    </>
  );
}
